import React from 'react';
import BackgroundComposer from './background/BackgroundComposer';
import ContactForm from './contact/ContactForm';
import ContactInfo from './contact/ContactInfo';
import SectionLabel from './common/SectionLabel';

const Contact = () => {
  return (
    <section id="contact" className="relative overflow-hidden bg-[#141414]">
      <BackgroundComposer>
        <div className="container relative z-10 mx-auto px-4">
          <div className="mb-16 max-w-3xl">
            <SectionLabel>Contact</SectionLabel>
            <h2 className="mt-6 text-4xl text-white md:text-6xl">Get in Touch</h2>
            <p className="mt-4 max-w-2xl text-sm leading-relaxed text-[#d0d0d0] md:text-base">
              Ready to elevate your brand and grow your business? Our team is here to help you
              create impactful digital solutions that drive real results.
            </p>
          </div>

          <div className="grid lg:grid-cols-2 gap-12 max-w-6xl mx-auto">
            <ContactForm />
            <ContactInfo />
          </div>
        </div>
      </BackgroundComposer>
    </section>
  );
};

export default Contact;